webpackJsonp([169315112914517],{

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/careers__hero.4e184ed8.jpg";

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _careers__hero = __webpack_require__(488);
	
	var _careers__hero2 = _interopRequireDefault(_careers__hero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Careers'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _careers__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'Careers'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content c-golden__wide' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/careers', activeClassName: 'is-active' },
	                'Careers'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__text c-golden__text--more-space' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'h1',
	                { className: 't-h1 mb30' },
	                'Why Join ATI'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light' },
	                'With over 40 years of experience recruiting talented individuals on an upward career trajectory, ATI continues to pave the way in developing and training Travel and Tourism professionals and leaders. Attracting multi-cultural and multi-faceted talent from around the globe, we take great pride in not only building a winning team, but also contributing to a better world. Common values amongst ATI Team Members are: passion for excellence, ambassadors of service, professional integrity and respect - providing a positive collaborative \u201Ccan do\u201D culture that embraces a Team with a diverse array of backgrounds, ideas, and interests. Our Team Members drive the creative, service-minded, entrepreneurial spirit that has always been the fabric of ATI and integral to our success!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'h2',
	                { className: 't-h2 mt30', style: { marginBottom: 25 } },
	                'We seek:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 't-p t-p-light t-ul' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Negotiators'
	                  ),
	                  ' - talented individuals who drive results and win-win relationships'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Relationship Builders'
	                  ),
	                  ' - people with passion and talent for fostering mutual successes with others'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Customer/Client Focus'
	                  ),
	                  ' - detail orientation and internal motivation to deliver excellence for our clients'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'International Students and Interns'
	                  ),
	                  ' - dedicated professionals start or grow their travel and tourism careers through ATI\u2019s exclusive USCIS approved (J1) traineeship programs for expanding knowledge of North America as a travel destination and learning the processes/procedures within a highly successful North American Inbound Tour Operator'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light mt20' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 't-bold' },
	                  'ATI\u2019s Human Resources Team looks forward to hearing from you!',
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'mailto:careers@americantours.com',
	                    className: 't-red t-bold'
	                  },
	                  'Careers@AmericanTours.com'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-careers-js-74b6407ec64e917f469f.js